import React from 'react';

type HeadProps = {
  className?: string;
  children?: React.ReactNode;
};

export const Head: React.FC<HeadProps> = ({ children, className = '' }) => {
  return <th className={className}>{children}</th>;
};
